import Lookup from 'src/componentes/select2';
import UnidadeEdit from 'src/paginas/unidade-medida/edit';

const UnidadeMedida = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/UnidadeMedidaLookup"
    editComponent={UnidadeEdit}
    {...rest}
  />
);

export default UnidadeMedida;
